// Feature: plans & billing, warehouse exports, SCIM provisioning + Teams bot (PLAN §22, §16, §17.1).
// Registers routes and nav entries via registerFeature(); see features/registry.ts.
import { createRoute } from "@tanstack/react-router";
import "./billing.css";
import { registerFeature } from "../registry";
import { BillingPage } from "@backstory/deployment-billing";
import { ExportsPage } from "./ExportsPage";
import { ScimPage } from "./ScimPage";
import { EnterpriseOfferPage } from "./EnterpriseOfferPage";

registerFeature({
  routes: (appRoute) => [
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/billing", component: BillingPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/billing/enterprise/$offer", component: EnterpriseOfferPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/exports", component: ExportsPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/scim", component: ScimPage }),
  ],
  nav: [
    { label: "Warehouse exports", to: "/orgs/$org/exports", section: "org", order: 60, needsOrg: true, scope: "admin", feature: "warehouse" },
    { label: "Provisioning", to: "/orgs/$org/scim", section: "org", order: 70, needsOrg: true, scope: "members", feature: "scim" },
  ],
});
